var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExpandMessage = function SvgExpandMessage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 14",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.22 8.494a.753.753 0 0 1 1.062-.002l3.724 3.7L8.718 8.48a.753.753 0 0 1 1.062-.002.747.747 0 0 1 .002 1.06L5.54 13.78a.753.753 0 0 1-1.063.002L.221 9.552a.747.747 0 0 1-.002-1.058m9.562-2.988a.753.753 0 0 1-1.062.002l-3.724-3.7L1.283 5.52a.753.753 0 0 1-1.062.002.747.747 0 0 1-.002-1.06L4.462.22A.753.753 0 0 1 5.524.218l4.257 4.23a.747.747 0 0 1 .001 1.058",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExpandMessage);
export { ForwardRef as Icon };
export default "img/element-icons/expand-message.b3c80a6.svg";